import { useFormik } from "formik";
import React, { useRef, useState, useContext } from "react";
import { BsSearch, BsUpload } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import * as yup from "yup";
import { uploadAudiService } from "../../services/audioServices";
import ClipLoader from "react-spinners/ClipLoader";
import { rootContexts } from "../../contexts/rootContexts";
import errorModel from "../Errors/ErrorModel";
import { scroller } from "react-scroll";

export default function OverviewSection() {
  const fileInputRef = useRef(null);

  console.log(fileInputRef, "fileInputRef");
  const [detect, setDetectBtn] = useState(false);
  const [fileName, setFileName] = useState("");
  const [filetype, setFiletype] = useState("");
  const [loader, setLoader] = useState(false);

  const { setAudioResult } = useContext(rootContexts);

  const scrollToResult = () => {
    scroller.scrollTo("result", {
      offset: 200,
      duration: 500,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  const formik = useFormik({
    initialValues: {
      audio: [],
      audPurpose: "Detection",
    },
    validationSchema: yup.object({
      audio: yup.mixed().required("required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoader(true);

      const result = await uploadAudiService(values);
      if (filetype === "mp3") {
        setTimeout(() => {
          setLoader(false);
          setLoader(false);
          setAudioResult(true);
          setDetectBtn(false);
          // errorModel("success", "audio is detected");

          scrollToResult();
          formik.resetForm();
          setDetectBtn(false);
          //  setServerError("")
          setLoader(false);
          fileInputRef.current.value = "";
        }, 1000);
        console.log("the reslut is ", result);
      } else {
        setTimeout(() => {
          setLoader(false);
          setLoader(false);
          setAudioResult(false);
          setDetectBtn(false);
          errorModel(
            "error",
            `Invalid audio format, please
          provide an audio file with the supported format`
          );
          formik.resetForm();
          setDetectBtn(false);
          //  setServerError("")
          setLoader(false);
          fileInputRef.current.value = "";
        }, 3000);
        console.log("the reslut is ", result);
      }

      // if(result.status){
      //   setLoader(false);
      //   setAudioResult(true)
      //   setDetectBtn(false);
      //   errorModel('success',result.message)

      // }
      // else{
      //   setLoader(false);
      //   setAudioResult(false)
      //   errorModel('error',result.message)
      //   console.log(result.message)
      // }
    },
  });
  const filehandler = (e) => {
    formik.setFieldValue("audio", e.target.files[0]);
    const Fileset = e.target.files[0];
    if (Fileset && Fileset.name.endsWith(".mp3")) {
      setFiletype("mp3");
    } else {
      setFiletype("mpall");
    }
    setFileName(e.target.files[0].name);
    setDetectBtn(true);
  };
  const detectHandler = () => {
    formik.resetForm();
    setDetectBtn(false);
    //  setServerError("")
    setLoader(false);
    fileInputRef.current.value = "";
  };
  return (
    <>
      <div className="container px-2 md:px-20 m-auto " id="overview">
        <div className="grid grid-cols-1 md:grid-cols-2 py-20 items-center">
          <div className="px-2 md:px-5 space-y-5 relative before:absolute before:right-0 before:h-full before:w-[1px] before:bg-beta">
            <h1 className="h1">Overview</h1>
            <p className="p">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. In eu
              mi bibendum neque egestas congue. Ullamcorper malesuada proin
              libero nunc consequat interdum varius. Ullamcorper malesuada proin
              libero nunc consequat interdum varius.
            </p>
          </div>
          <div className="space-y-5 px-2 md:px-20">
            <p className="p">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. In eu
              mi bibendum neque egestas congue.
            </p>
            <p>
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <input
                    type="file"
                    name="audio"
                    id="audioupload"
                    onChange={filehandler}
                    ref={fileInputRef}
                    accept="audio/*"
                    className=" hidden w-full h-10"
                    onBlur={formik.handleBlur}
                  />
                </div>
                {detect ? (
                  <div>
                    <div className="flex gap-x-4 items-center justify-between">
                      <p className="p flex py-3 items-center gap-x-3 ">
                        {fileName}{" "}
                        <IoIosClose
                          className="mt-1 cursor-pointer text-2xl"
                          onClick={() => {
                            detectHandler();
                          }}
                        />{" "}
                      </p>

                      <button
                        type="submit"
                        className="btn-warning"
                        disabled={loader}
                      >
                        Detect
                        {loader ? (
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loader}
                            // cssOverride={override}
                            size={15}
                            className="relative top-1 left-2"
                            aria-label="Loading "
                            data-testid="loader"
                          />
                        ) : (
                          <BsSearch className="text-[#394C34] mt-1" />
                        )}
                      </button>
                    </div>
                    {/* {serverError ? <p className="text-[16px] text-red-500 font-imprima">{serverError}</p>:null} */}
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      fileInputRef.current.click();
                      // window.document.getElementById('audioupload').click();
                    }}
                    className="btn-primary"
                  >
                    Upload <BsUpload className="text-white " />{" "}
                  </button>
                )}
              </form>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
